const T_PREFIX = "mob-menu";

export const mobMenuTrns = {
  clones: `${T_PREFIX}.clones`,
  inquiries: `${T_PREFIX}.inquiries`,
  cabinet: `${T_PREFIX}.cabinet`,
  favourites: `${T_PREFIX}.favourites`,
  watchlist: `${T_PREFIX}.watchlist`,
  login: `${T_PREFIX}.login`,
  signUp: `${T_PREFIX}.sign-up`,
};
